var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ax-list-panel',_vm._g(_vm._b({ref:"panel"},'ax-list-panel',_vm.listPanel.attrs,false),_vm.listPanel.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }